import {
    Button,
    FormControl,
    Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
    autoCompleteSelectOptionsFormat,
    extractDataGroup,
    extractSelectedValues,
    selectedListValues,
} from "../../../../../utility/helper";
import { listItemProp } from "utility/types";
import MultiSelectAutoCompleteV1 from "shared-component/autocomplete-checkbox-multiple-v1";
import { ChangeEvent, useEffect, useState } from "react";
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import Papa from "papaparse";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CdadHeaderFileUploadDialog from "../../CdadHeaderFileUploadDialog";
import RangeDropdown from "shared-component/range-component";
 
dayjs.extend(utc);
 
const VehicleFilter = (props: any) => {
    const [vinFilterData, setVinFilterData] = useState<string[]>(extractDataGroup(props.unNestedParamData, "vins") ?? []);
    const [vehicleName, setVehicleName] = useState<string[]>(extractDataGroup(props.unNestedParamData, "vehicleName") ?? []);
    const [modelYear, setModelYear] = useState<string[]>(extractDataGroup(props.unNestedParamData, "ModelYear") ?? []);
    const [familyName, setFamilyName] = useState<string[]>(extractDataGroup(props.unNestedParamData, "FamilyName") ?? []);
    const [dispatchModelType, setDispatchModelType] = useState<string[]>(extractDataGroup(props.unNestedParamData, "DispatchModelType") ?? []);
    const [odometer, setOdometer] = useState<any>(extractDataGroup(props.unNestedParamData, "odometer") ?? null);
    const [fileUploadOpen, setFileUploadOpen] = useState<boolean>(false);
    const [fileName, setFileName] = useState(props?.vinListFromFile ? sessionStorage.getItem('vinCSVFileName') : "");
    const [vinListData, setVinListData] = useState(props?.vinListFromFile ?? []);
 
 
    useEffect(() => {
        props.vinListFile(vinListData)
    }, [vinListData, props])
 
    const handleSelection = (selectedList: listItemProp[], filter: string) => {
        const value: string[] = selectedListValues(selectedList);
        switch (filter) {
            case 'vehicleName':
                setVehicleName(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'ModelYear':
                setModelYear(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'DispatchModelType':
                setDispatchModelType(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'vins':
                setVinFilterData(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'FamilyName':
                setFamilyName(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
        }
 
    }
 
    const downloadCSVSample = () => {
        const blob = new Blob(["VINs"], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", "sampleVinFile.csv");
        a.click();
    };
 
    const getVINFromCsv = (event: ChangeEvent<HTMLInputElement>) => {
        let vinList: any = [];
        const sFiles: any = event.target.files;
        if (sFiles?.length > 0) {
            setFileName(sFiles[0].name);
            sessionStorage.setItem('vinCSVFileName', sFiles[0]?.name);
            Papa.parse(sFiles[0], {
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    const dataCsv = results.data;
                    dataCsv.forEach((item: any) => {
                        vinList.push(item?.VINs);
                    });
                },
            });
        }
        return setVinListData(vinList);
    };
 
 
  const updateOdometerRange = (value: any) => {
    setOdometer(value);
    props.getUpdatedList({
      title: "odometer",
      value: value,
    });
  }
 
    return (
        <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
            <div className="signalFilterList" style={{ padding: "8px" }}>
                <Tooltip title={vehicleName?.length > 0 ? vehicleName?.toString() : "Select / Search Vehicle Models"} placement="right">
                    <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                        <MultiSelectAutoCompleteV1
                            items={autoCompleteSelectOptionsFormat(props.vehicleName)}
                            label="Select / Search Vehicle Models"
                            selectAllLabel="Select All"
                            onChange={(value: listItemProp[]) => {
                                // if (value?.length > 0) handleCANSignalSelection(value)
                                handleSelection(value, 'vehicleName')
                            }}
 
                            selectedValues={extractSelectedValues(vehicleName)}
                            disabled={props.vehicleName?.length === 0}
                        />
                    </FormControl>
                </Tooltip>
            </div>
            <div className="signalFilterList" style={{ padding: "8px" }}>
                <Tooltip title={modelYear?.length > 0 ? modelYear?.toString() : "Select / Search Vehicle Model Year"} placement="right">
                    <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                        <MultiSelectAutoCompleteV1
                            items={autoCompleteSelectOptionsFormat(props.modelYear)}
                            label="Select / Search Vehicle Model Year"
                            selectAllLabel="Select All"
                            onChange={(value: listItemProp[]) => {
                                // if (value?.length > 0) handleCANSignalSelection(value)
                                handleSelection(value, 'ModelYear')
                            }}
 
                            selectedValues={extractSelectedValues(modelYear)}
                            disabled={props.modelYear?.length === 0}
                        />
                    </FormControl>
                </Tooltip>
            </div>
            <div className="signalFilterList" style={{ padding: "8px" }}>
                <Tooltip title={familyName?.length > 0 ? familyName?.toString() : "Select / Search Vehicle Model Year"} placement="right">
                    <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                        <MultiSelectAutoCompleteV1
                            items={autoCompleteSelectOptionsFormat(props?.familyCd)}
                            label="Select / Search Family Name"
                            selectAllLabel="Select All"
                            onChange={(value: listItemProp[]) => {
                                // if (value?.length > 0) handleCANSignalSelection(value)
                                handleSelection(value, 'FamilyName')
                            }}
                            selectedValues={extractSelectedValues(familyName)}
                            disabled={props.familyCd?.length === 0}
 
                        />
                    </FormControl>
                </Tooltip>
            </div>
            <div className="signalFilterList" style={{ padding: "8px" }}>
                <Tooltip title={dispatchModelType?.length > 0 ? dispatchModelType?.toString() : "Select / Search Dispatch Model Type"} placement="right">
                    <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                        <MultiSelectAutoCompleteV1
                            items={autoCompleteSelectOptionsFormat(props.dispatchModelType)}
                            label="Select / Search Dispatch Model Type"
                            selectAllLabel="Select All"
                            onChange={(value: listItemProp[]) => {
                                // if (value?.length > 0) handleCANSignalSelection(value)
                                handleSelection(value, 'DispatchModelType')
                            }}
 
                            selectedValues={extractSelectedValues(dispatchModelType)}
                            disabled={props.dispatchModelType?.length === 0}
                        />
                    </FormControl>
                </Tooltip>
            </div>
            <div className="signalFilterList" style={{ padding: "8px" }}>
                <Tooltip title={vinFilterData?.length > 0 ? vinFilterData?.toString() : "Select / Search VIN"} placement="right">
                    <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                        <MultiSelectAutoCompleteV1
                            items={autoCompleteSelectOptionsFormat(props.vinList)}
                            label="Select / Search VIN"
                            selectAllLabel="Select All"
                            onChange={(value: listItemProp[]) => {
                                // if (value?.length > 0) handleCANSignalSelection(value)
                                handleSelection(value, 'vins')
                            }}
 
                            selectedValues={extractSelectedValues(vinFilterData)}
                            disabled={props.vinList?.length === 0}
                        />
                    </FormControl>
                </Tooltip>
            </div>
            <div className="signalFilterList" style={{ padding: "8px" }}>
                <Tooltip title={odometer ? JSON.stringify(odometer) : "Select Odometer"} placement="top">
                    <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                        <RangeDropdown value={odometer} label="Odometer" minLabel="Min Odometer" maxLabel="Max Odometer" updateRangeData={updateOdometerRange} minDataValue={props?.odometerMin} maxDataValue={props?.odometerMax} />
                    </FormControl>
                </Tooltip>
            </div>
            {vinListData?.length === 0 ? <div style={{ padding: "8px" }}>
                <Tooltip title={"VIN File Upload"} placement="right">
                    <Button
                        variant="outlined"
                        sx={{
                            p: '14px', display: 'flex',
                            justifyContent: 'flex-start',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            borderRadius: "8px", width: "215px",
                            fontSize: "12px", textAlign: "left", alignItems: "flex-start"
                        }}
                        onClick={() => setFileUploadOpen(!fileUploadOpen)}
                        startIcon={<MoveToInboxIcon
                        />}
                    >
                        VIN Upload
                    </Button>
                </Tooltip>
            </div> :
                <div style={{ padding: "8px" }}>
                    <Tooltip title={"VIN File Upload"} placement="right">
                        <Button
                            variant="outlined"
                            sx={{
                                p: '14px', display: 'flex',
                                justifyContent: 'flex-start',
                                border: '1px solid rgba(0, 0, 0, 0.1)',
                                borderRadius: "8px", width: "215px",
                                fontSize: "12px", textAlign: "left", alignItems: "flex-start"
                            }}
                            onClick={() => setFileUploadOpen(!fileUploadOpen)}
                            startIcon={<CheckBoxIcon
                            />}
                        >
                            VIEW Uploaded VIN
                        </Button>
                    </Tooltip>
                </div>}
            <CdadHeaderFileUploadDialog fileUploadOpen={fileUploadOpen} fileName={fileName} setFileUploadOpen={() => setFileUploadOpen(false)} fileUploadFunc={getVINFromCsv} downloadCSVSample={downloadCSVSample} setFileName={setFileName} setVinListData={setVinListData} vinListData={vinListData} />
        </div>
    );
};
 
export default VehicleFilter;
 